var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MenuStyle1'),_c('PageHeader',{attrs:{"pageTitle":"Arcticle Processing Charges","parentPage":"For Authors"}}),_c('ProcessingChargesComponentVue'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }